module.exports = __webpack_public_path__ + "static/media/wenatives.0e06f413.svg";